<a href="javaScript:;" class="back-to-top"><i class="fa fa-angle-double-up"></i> </a>

<footer class="footer">
    <div class="container">
        <div class="text-center">
            Copyright © {{anio}} CONADE
            <br>
            <p>v{{appVersion}}</p>    
        </div>
    </div>
</footer>
